module.exports = __webpack_public_path__ + "img/design_movie.e9d47a00.jpg";